module.exports = __webpack_public_path__ + "static/media/person_mbsb.6162af07.png";